import { useMutation } from 'react-query';
import deleteRoomOwner from '../requests/deleteRoomOwner';

const useDeleteRoomOwnerMutation = (options) =>
  useMutation(({ ownerId, room }) => deleteRoomOwner(ownerId, room), options);

export default useDeleteRoomOwnerMutation;
